import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from "@angular/core";
import { environment } from "../../../environments/environment";
import { ApiConfiguration } from "../cms-api/api-configuration";
import { ApiModule } from "../cms-api/api.module";

export function provideCmsApiWithInterceptor(): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: ApiConfiguration,
            useFactory: () => {
                const url = environment.cmsApiUrl;
                const apiConfiguration = new ApiConfiguration();
                apiConfiguration.rootUrl = url;
                return apiConfiguration;
            }
        },
        importProvidersFrom(ApiModule.forRoot({
            rootUrl: environment.cmsApiUrl
        }))
    ]);
}